module.exports = __webpack_public_path__ + "static/media/ASTOP.96ce337c.svg";